import { useIntl } from 'react-intl';

import { Filters_DEPRECATED } from '~/components/Shared/Filters_DEPRECATED/Filters_DEPRECATED';
import { Field } from '~/components/Shared/Filters_DEPRECATED/types';
import { Filter } from '~/evifields/src/types/Filter';

interface Props {
  filters: Filter[];
  onChange: (updatedFilters: Filter[]) => void;
}

export const ModelLibraryFilters = ({ filters, onChange }: Props) => {
  const intl = useIntl();

  const fields: Record<string, Field> = {
    modelState: {
      id: 'modelState',
      label: intl.formatMessage({
        id: 'ModelLibraryFilters.modelState',
        defaultMessage: 'Model State',
        description: 'Label for model state filter',
      }),
      type: 'enum_set',
      whitelistOperatorIds: ['contains_any'],
      settings: {
        options: [
          {
            label: intl.formatMessage({
              id: 'ModelLibraryFilters.draft',
              defaultMessage: 'Draft',
              description: 'Draft model state option',
            }),
            value: 'draft',
          },
          {
            label: intl.formatMessage({
              id: 'ModelLibraryFilters.inProgress',
              defaultMessage: 'In Progress',
              description: 'In progress model state option',
            }),
            value: 'in_progress',
          },
          {
            label: intl.formatMessage({
              id: 'ModelLibraryFilters.published',
              defaultMessage: 'Published',
              description: 'Published model state option',
            }),
            value: 'published',
          },
          {
            label: intl.formatMessage({
              id: 'ModelLibraryFilters.suspended',
              defaultMessage: 'Suspended',
              description: 'Suspended model state option',
            }),
            value: 'suspended',
          },
        ],
      },
    },
  };

  return (
    <Filters_DEPRECATED
      fields={fields}
      filters={filters}
      onChange={onChange}
      options={{
        disableClearFilters: true,
        disableManageFilters: true,
        disableRemoveFilter: true,
      }}
    />
  );
};
